import React from 'react';
import { CheckCircle, X } from 'lucide-react';

const SuccessNotification = ({ isOpen, onClose, title, message }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-gray-900 border border-gray-800 p-8 max-w-md w-full text-center">
        <div className="flex justify-end mb-4">
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors"
            aria-label="Close notification"
          >
            <X className="h-6 w-6" />
          </button>
        </div>
        
        <div className="mb-6">
          <CheckCircle className="h-16 w-16 text-green-400 mx-auto mb-4" />
          <h3 
            className="text-2xl font-bold text-white mb-2"
            style={{ fontFamily: '"Times New Roman", serif' }}
          >
            {title}
          </h3>
          <p className="text-gray-300 text-lg">
            {message}
          </p>
        </div>
        
        <button
          onClick={onClose}
          className="px-6 py-3 bg-white text-black hover:bg-gray-200 transition-all duration-300 font-medium"
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default SuccessNotification;